import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-center py-4 text-gray-400">
      <p>
        © Designed & Made by Leon Tang (me) 😃. Last updated February 2025{' '}
        <a href="https://kyancox.com/" target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:underline">
          Website Inspiration
        </a>
      </p>
    </footer>
  );
};

export default Footer;
